export const isPlain = <F extends () => void>(callback: unknown): callback is F  =>
    typeof callback === "function"
;